module.exports = __webpack_public_path__ + "static/img/xiaomishu.2db1707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/xiaomishu.jpg
// module id = iLAI
// module chunks = 0